import { useScrollLock } from "@/hooks/useScrollLock";
import "@/styles/BrandNotFoundModal.less";
import { Button, Modal } from "antd";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

interface BrandNotFoundModalProps {
  open: boolean;
  onClose: () => void;
  onJoinBeta: () => void;
  brandName?: string;
}

export const BrandNotFoundModal: React.FC<BrandNotFoundModalProps> = ({
  open,
  onClose,
  onJoinBeta,
  brandName,
}) => {
  const { t } = useTranslation();

  // 防止移动端滚动穿透
  useScrollLock(open);
  // 定义按钮样式对象
  const buttonStyle = {
    background: "#2BBDB2",
    borderColor: "#2BBDB2",
    color: "#ffffff",
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("brand_not_found.btn_cancel")}
        </Button>,
        <Button
          key="join"
          type="primary"
          onClick={onJoinBeta}
          className="brand-not-found-btn"
          style={buttonStyle}
        >
          {t("brand_not_found.btn_join")}
        </Button>,
      ]}
      title={t("brand_not_found.title")}
      centered
    >
      <div style={{ padding: "20px 0" }}>
        <p>
          <Trans
            i18nKey="brand_not_found.message"
            values={{ brandName: brandName || "" }}
            components={[<b key="0" />]}
          />
        </p>
        {/* <p>加入内测联盟可获得：</p>
        <ul>
          <li>品牌AI洞察分析</li>
          <li>竞品对比数据</li>
          <li>舆情监控报告</li>
          <li>专属客服支持</li>
        </ul>*/}
      </div>
    </Modal>
  );
};

export default BrandNotFoundModal;
